import App from './AppEmbed.svelte';

const app = new App({
	target: document.body,
	props: {}
});

export default app;